import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialogRef, MatSnackBar, MAT_DIALOG_DATA } from "@angular/material";
import { BuyIntentionService} from "../../../core/e-commerce/_services/buy-intention.service";
import { BuyIntentionForUpdate } from "../../../persistence/dto/buy-intention-for-update";

@Component({
    selector: 'kt-dialog-buy-intention-geozone',
    templateUrl: './dialog-buy-intention-geozone.component.html',
    styleUrls: ['./dialog-buy-intention-geozone.component.scss'],
})
export class DialogBuyIntentionGeoZoneComponent implements OnInit { 

    isLoadingResults: boolean = false;
    crmintentionEditForm: FormGroup;
    intentionId : number;
    @ViewChild('inputZone') inputZone: ElementRef;

    constructor(
        public dialogRef: MatDialogRef<DialogBuyIntentionGeoZoneComponent>,
        private cdr: ChangeDetectorRef,
        private intentionService: BuyIntentionService,
        private _snackBar: MatSnackBar,
        @Inject(MAT_DIALOG_DATA)
		    public data: intentionGeoZoneData
      ) { }

    ngOnInit(): void {

    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  guardarCambios(){
    if(isNaN(this.inputZone.nativeElement.value)){
      this.openSnackBar('El formato de la zona es incorrecto!', 'Error');
      return;
    }
    
    this.isLoadingResults = true;
    this.cdr.detectChanges();

    let updateDto: BuyIntentionForUpdate = {
      intentionId: 0,
      newAssignedGeoZoneLevelId: 0
    };

    updateDto.intentionId = this.data.intentionId;

    if (this.inputZone && this.inputZone.nativeElement.value) {
      updateDto.newAssignedGeoZoneLevelId = this.inputZone.nativeElement.value;
    }
    else{ 
      this.openSnackBar('Ingrese la nueva zona!', 'Error');
      this.isLoadingResults = false;
      this.cdr.detectChanges(); 
      return;
    }

    this.intentionService.updateBuyIntention(updateDto).subscribe(x => {
      this.openSnackBar('Se actualizó la zona correctamente!', 'Ok');
      this.isLoadingResults = false;
      this.cdr.detectChanges(); 
      this.dialogRef.close(updateDto.newAssignedGeoZoneLevelId);
    },
    error => { 
        if(error.status === 404){
          this.openSnackBar('La zona ingresada no existe!', 'Error');
        } 
        else{
          this.openSnackBar('Error al actualizar la zona!', 'Error');
        }
        this.isLoadingResults = false;
        this.cdr.detectChanges(); 
    })
  }
}


export interface intentionGeoZoneData{
	intentionId: number;
	geoZone: number;
}